/**
 * @author wangjunfeng
 */
// 本地翻译
export default {
  'zh-CN': {
    accountSetup: '账户设置',
    switchLanguage: '切换语言',
    helpCenter: '帮助中心',
    logOut: '退出登录',
    chooseLanguage: '选择语言',
    cancel: '取消',
    determine: '确定',
    failGetLanguage: '获取语言列表失败',
    settings: '设置',
    taskProcess: '任务进程',
    preferences: '偏好设置'
  },
  en: {
    accountSetup: 'Account settings',
    switchLanguage: 'Switch languages',
    helpCenter: 'Help Center',
    logOut: 'Log out',
    chooseLanguage: 'Selective language',
    cancel: 'Cancel',
    determine: 'Confirm',
    failGetLanguage: '获取语言列表失败',
    settings: 'Setting',
    taskProcess: 'Task process',
    preferences: 'Preferences'
  },
  jp: {
    accountSetup: 'アカウントの設定',
    switchLanguage: '言語を切り替え',
    helpCenter: 'ヘルプセンター',
    logOut: 'ログアウト',
    chooseLanguage: '言語を選択',
    cancel: 'キャンセル',
    determine: 'を選択します',
    failGetLanguage: '言語リストの取得に失敗しました'
  }
}
